import { CalendarEventGuest, ExternalConnectionContact } from '@griply/types';

const SUGGESTION_LIMIT = 8;

export type FilterContactSuggestionsOptions = {
  contacts: ExternalConnectionContact[];
  draft: string;
  guests: CalendarEventGuest[];
};

export const filterContactSuggestions = ({
  contacts,
  draft,
  guests,
}: FilterContactSuggestionsOptions): ExternalConnectionContact[] => {
  const query = draft.trim().toLowerCase();
  if (!query) {
    return [];
  }

  const guestEmails = new Set(guests.map(({ email }) => email.toLowerCase()));

  return contacts
    .filter(({ name, email }) => {
      if (guestEmails.has(email.toLowerCase())) {
        return false;
      }
      return (
        email.toLowerCase().includes(query) ||
        !!name?.toLowerCase().includes(query)
      );
    })
    .slice(0, SUGGESTION_LIMIT);
};
